import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const STORAGE_KEY = 'hvkurz_cookie_consent_v1';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (!v) {
        // Kleiner Delay, damit der Banner nicht sofort den Seitenaufbau dominiert
        const t = setTimeout(() => setVisible(true), 600);
        return () => clearTimeout(t);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        accepted: true,
        at: new Date().toISOString(),
      }));
    } catch { /* ignore */ }
    setVisible(false);
  };

  // Banner nur auf öffentlichen Seiten zeigen — eingeloggte Nutzer im Portal/Admin
  // haben bereits in den Onboarding-Flows zugestimmt; der Banner würde dort nur Buttons überlagern.
  const path = location?.pathname || '';
  const isPrivateArea = path.startsWith('/portal') || path.startsWith('/admin') || path === '/login';
  if (isPrivateArea) return null;

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie-Hinweis"
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[9998] animate-in fade-in slide-in-from-bottom-4 duration-300"
    >
      <div className="relative bg-white border border-gray-200 shadow-2xl rounded-xl overflow-hidden">
        {/* Gold-Akzentstreifen */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-brand-navy via-brand-gold to-brand-navy" />

        <div className="p-5 pr-10">
          <div className="flex items-start gap-3 mb-3">
            <div className="shrink-0 w-9 h-9 rounded-full bg-brand-navy/5 border border-brand-navy/10 flex items-center justify-center">
              <Cookie className="w-4 h-4 text-brand-gold" />
            </div>
            <div>
              <p className="font-semibold text-brand-navy text-sm">Hinweis zu Cookies</p>
              <p className="text-gray-600 text-xs mt-1 leading-relaxed">
                Diese Website verwendet technisch notwendige Cookies, um die Funktionalität und einen
                sicheren Betrieb zu gewährleisten. Details finden Sie in unserer{' '}
                <Link
                  to="/datenschutz"
                  className="underline text-brand-navy hover:text-brand-gold font-medium"
                  data-testid="cookie-link-datenschutz"
                >
                  Datenschutzerklärung
                </Link>.
              </p>
            </div>
          </div>

          <button
            type="button"
            onClick={accept}
            data-testid="cookie-accept-btn"
            className="w-full inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-brand-navy hover:bg-brand-navy-dark text-white text-sm font-medium rounded-lg transition-colors"
          >
            Verstanden
          </button>
        </div>

        <button
          type="button"
          onClick={accept}
          aria-label="Hinweis schließen"
          data-testid="cookie-close-btn"
          className="absolute top-3 right-3 p-1.5 rounded-md text-gray-400 hover:text-brand-navy hover:bg-gray-100 transition"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
